var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fill",
    stroke: "none",
    strokeWidth: 0.1,
    transform: "translate(3.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "19 10.0005 35.5 10.0005 35.5 8.5005 19 8.5005"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10 6.2495 35.5 6.2495 35.5 4.7505 10 4.7505"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26 14.0005 35.5 14.0005 35.5 12.5005 26 12.5005"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.500500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5,4.9995 L42.692,4.9995 L43.327,7.7485 L46,9.1965 L46,12.4995 L44.251,12.4995 C43.75,11.2955 42.566,10.4995 41.25,10.4995 C40.12,10.4995 39.086,11.0875 38.5,12.0175 L38.5,4.9995 Z M41.25,11.9995 C42.215,11.9995 43,12.7855 43,13.7495 C43,14.7145 42.215,15.4995 41.25,15.4995 C40.286,15.4995 39.5,14.7145 39.5,13.7495 C39.5,12.7855 40.286,11.9995 41.25,11.9995 L41.25,11.9995 Z M44.635,6.7515 L43.885,3.4995 L38.5,3.4985 L38.5,0.4995 L0,0.4995 L0,1.9995 L37,1.9995 L37,13.9995 L38.009,13.9995 C38.138,15.6755 39.542,16.9995 41.25,16.9995 C42.958,16.9995 44.363,15.6755 44.491,13.9995 L47.5,13.9995 L47.5,8.3025 L44.635,6.7515 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.50b62438f61cc02b52ff0d779fc7b549.svg";
export { ForwardRef as ReactComponent };